'use client';
import React from 'react';
import { ArrowRight, Sparkles, Zap } from 'lucide-react';

export default function FinalCTASection() {
  return (
    <section className="py-24 relative overflow-hidden">
      {/* Background */}
      <div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(135deg, #0B0F19 0%, #141A2E 50%, #0F1525 100%)',
        }}
      />
      {/* Glow Effects */}
      <div
        className="absolute top-0 left-1/4 w-96 h-96 rounded-full opacity-25 pointer-events-none"
        style={{ background: 'radial-gradient(circle, rgba(0,212,255,0.5) 0%, transparent 70%)', filter: 'blur(40px)' }}
      />
      <div
        className="absolute bottom-0 right-1/4 w-80 h-80 rounded-full opacity-20 pointer-events-none"
        style={{ background: 'radial-gradient(circle, rgba(167,139,250,0.5) 0%, transparent 70%)', filter: 'blur(40px)' }}
      />

      {/* Grid pattern overlay */}
      <div
        className="absolute inset-0 pointer-events-none opacity-5"
        style={{
          backgroundImage: 'linear-gradient(rgba(0,212,255,0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(0,212,255,0.3) 1px, transparent 1px)',
          backgroundSize: '60px 60px',
        }}
      />

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Badge */}
        <div
          className="inline-flex items-center gap-2 text-xs font-semibold px-4 py-2 rounded-full mb-8"
          style={{
            background: 'rgba(0,212,255,0.12)',
            color: '#00D4FF',
            border: '1px solid rgba(0,212,255,0.25)',
            fontFamily: 'JetBrains Mono, monospace',
          }}
        >
          <Sparkles size={12} />
          No Credit Card Required
        </div>

        {/* Headline */}
        <h2
          className="text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight mb-6 tracking-tight"
          style={{ color: '#F0F4FF' }}
        >
          Stop managing your business.{' '}
          <span className="gradient-cyan-lavender-text">
            Let AI run it with you.
          </span>
        </h2>

        {/* Subtext */}
        <p
          className="text-lg leading-relaxed mb-10 max-w-2xl mx-auto"
          style={{ color: 'rgba(240,244,255,0.60)' }}
        >
          AgentOS is your AI business partner. It remembers everything, prioritizes your day, and helps you close more — without burning out.
        </p>

        {/* CTAs */}
        <div className="flex flex-wrap items-center justify-center gap-4 mb-8">
          <a
            href="https://agentos-ai-vgojf93.public.builtwithrocket.new/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 font-bold text-base px-8 py-4 rounded-xl transition-all"
            style={{
              background: 'linear-gradient(135deg, #00D4FF, #0099CC)',
              color: '#0B0F19',
              boxShadow: '0 8px 32px rgba(0,212,255,0.40)',
            }}
            onMouseEnter={(e) => {
              (e.currentTarget as HTMLElement).style.transform = 'translateY(-2px)';
              (e.currentTarget as HTMLElement).style.boxShadow = '0 12px 40px rgba(0,212,255,0.55)';
            }}
            onMouseLeave={(e) => {
              (e.currentTarget as HTMLElement).style.transform = 'translateY(0)';
              (e.currentTarget as HTMLElement).style.boxShadow = '0 8px 32px rgba(0,212,255,0.40)';
            }}
          >
            <Zap size={18} strokeWidth={2.5} />
            Request Early Access
            <ArrowRight size={16} />
          </a>
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 font-semibold text-base px-8 py-4 rounded-xl transition-all"
            style={{
              background: 'rgba(255,255,255,0.08)',
              color: '#F0F4FF',
              border: '1.5px solid rgba(255,255,255,0.15)',
            }}
            onMouseEnter={(e) => {
              (e.currentTarget as HTMLElement).style.background = 'rgba(167,139,250,0.12)';
              (e.currentTarget as HTMLElement).style.borderColor = 'rgba(167,139,250,0.30)';
              (e.currentTarget as HTMLElement).style.color = '#A78BFA';
              (e.currentTarget as HTMLElement).style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              (e.currentTarget as HTMLElement).style.background = 'rgba(255,255,255,0.08)';
              (e.currentTarget as HTMLElement).style.borderColor = 'rgba(255,255,255,0.15)';
              (e.currentTarget as HTMLElement).style.color = '#F0F4FF';
              (e.currentTarget as HTMLElement).style.transform = 'translateY(0)';
            }}
          >
            Talk to Us
          </a>
        </div>

        <p className="text-sm" style={{ color: 'rgba(240,244,255,0.30)' }}>
          No contracts. Cancel anytime. Free trial included.
        </p>
      </div>
    </section>
  );
}
